import { observer } from 'mobx-react';
import { T } from '../../../../../../../Translations';
import { EitherLearningCollectionStore } from '../../../../../Types';

interface Props {
  store: EitherLearningCollectionStore;
}

function ProductLicense({ store }: Props) {
  return store.selectedProductLicense
    .map(() => (
      <div className="text-sm">
        <T kind="Program types available for this collection will be shown here when you start adding programs" />
      </div>
    ))
    .getOrElse(() => (
      <div className="text-sm">
        <T kind="Choose a license to start adding programs to this collection" />
      </div>
    ));
}

export default observer(ProductLicense);
